import { k as jsxRuntimeExports } from "./doenetml-drNYjJiF.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-CDZbHBy-.js";
import { r as renderMarkupBody } from "./markupRenderer-rPpSzHPv.js";
const c = React__default.memo(function C(props) {
  const { id, SVs, children } = useDoenetRenderer(props);
  const body = renderMarkupBody({ SVs, children });
  if (body === null) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("code", { id, style: { margin: "12px 0" }, children: body });
});
export {
  c as default
};
